import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import {
  isSitecorePlaceholderImage,
  GenericLinkDirective,
  GenericRichTextDirective,
} from '@core/jss-utils';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { ListItemComponent } from '@legacy/common-ui-partials';
import { ImageComponent } from '@legacy/common-ui-utility-components';

import { HubSubVariant } from './list-variant-hub.model';
import { ListVariantBaseComponent } from '../list-variant.base.component';
import { ComposableCardConfig } from '../../../composables/card/card.model';
import { ComposableCardComponent } from '../../../composables/card/card.component';

@Component({
  selector: 'wl-list-variant-hub',
  templateUrl: './list-variant-hub.component.html',
  styleUrls: [
    './list-variant-hub.component.ed.scss',
    './list-variant-hub.component.essent.scss',
  ],
  standalone: true,
  imports: [
    ComposableCardComponent,
    JssModule,
    ImageComponent,
    GenericLinkDirective,
    ListItemComponent,
    GenericRichTextDirective,
  ],
})
export class ListVariantHubComponent
  extends ListVariantBaseComponent
  implements OnInit
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subVariant: HubSubVariant = 'brand';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() cardConfig?: ComposableCardConfig;

  backgroundColorClass?: string;

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.cardConfig) {
      this.cardConfig.borderRoundingClass = 'rounded-top';
      this.backgroundColorClass = this.cardConfig.backgroundColorClass;
      this.cardConfig.backgroundColorClass = '';
    }
  }

  get image(): string | undefined {
    return isSitecorePlaceholderImage(this.imageSettings?.image?.src)
      ? undefined
      : this.imageSettings?.image?.src;
  }

  get hasDarkBackground(): boolean {
    return ['bg-brand-gradient', 'bg-brand'].includes(
      this.backgroundColorClass || 'unknown'
    );
  }
}
